import { apiSlice } from "./apiSlice";
import {AssignPricePlanParams, CreditCardQueryParams, CreditCardsData, PricePlan} from '../../types/billingTypes';

export const creditCardsInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCreditCards: builder.query<CreditCardsData, CreditCardQueryParams>({
            query: ({ accountID, page , perPage}) => `/cc?account_id=${accountID}&page=${page}&per_page=${perPage}`,
            providesTags: ["CreditCards"]
        }),
        getPricePlans: builder.query<PricePlan[], void>({
            query: () => `/price_plans`
        }),
        assignPricePlan: builder.mutation<void, AssignPricePlanParams>({
            query: ({pricePlanID, accountID}) => ({
                url: `/accounts/${accountID}/assign_price_plan`,
                method: 'POST',
                body: {price_plan_id: pricePlanID}
            }),
        }),
    })
});

export const creditCardsEndpoints = creditCardsInjectedEndpoints.endpoints;
export const {
    useGetCreditCardsQuery,
    useAssignPricePlanMutation,
    useGetPricePlansQuery
} = creditCardsInjectedEndpoints;
